export const mailsEN = {
  checkpoint: 'You have to confirm the email to view the exercises',
  verification: {
    expired: 'Invalid or expired code',
    verificated: 'Invalid or expired code',
    processing: 'AptisGo is processing your verification'
  }
}
